import { getDefaultConfig } from 'connectkit';
import { HttpTransportConfig } from 'viem';
import { createConfig, fallback, http, webSocket } from 'wagmi';
import { walletConnect } from 'wagmi/connectors';

import { chains, monadMainnet, monadTestnet } from './chains';
import { backpackConnector } from './connectors/backpack';
import { baseAccountConnector } from './connectors/baseAccount';
import { binanceConnector } from './connectors/binance';
import { bitgetConnector } from './connectors/bitget';
import { coinbaseConnector } from './connectors/coinbase';
import { hahaConnector } from './connectors/haha';
import { metamaskConnector } from './connectors/metamask';
import { okxConnector } from './connectors/okx';
import { phantomConnector } from './connectors/phantom';
import { privyGoogleConnector } from './connectors/privyGoogle';

const commonHttpParams = [
  undefined,
  {
    batch: false,

    // looser timeout to cater slow network, Default: 10_000
    // ether js default is 2min, which is using, align with it
    timeout: 120_000, // 2 minutes
  } satisfies HttpTransportConfig,
] as const;

const defaultConfig = {
  chains: chains,
  connectors: [
    privyGoogleConnector({ chains }),
    bitgetConnector(),
    metamaskConnector(),
    okxConnector(),
    binanceConnector(),
    phantomConnector(),
    // hahaConnector(),
    baseAccountConnector(),
    coinbaseConnector(),
    backpackConnector(),
  ],
  ssr: true,
  batch: {
    multicall: false,
  },
  transports: {
    [monadMainnet.id]: http(...commonHttpParams),
    [monadTestnet.id]: http(...commonHttpParams),
  },
};
const getConfig = () => createConfig(getDefaultConfig({
  appName: 'LeverUp',
  appIcon: 'https://app.leverup.xyz/images/logo.svg',
  appDescription:
    'LeverUp is an LP-Free perpetuals exchange delivering uncapped open interest, 100% fee redistribution to traders, and leverage up to 1001x',
  appUrl: 'https://app.leverup.xyz',
  walletConnectProjectId: process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID!,
  ...defaultConfig,
}));

const defaultWsConfig = fallback(
  [
    webSocket(undefined, {
      reconnect: true,
      keepAlive: {
        interval: 10_000, // 10 second
      },
    }),
    http(...commonHttpParams),
  ],
  {},
);

const getWsConfig = () =>
  createConfig({
    ...defaultConfig,
    transports: {
      [monadMainnet.id]: defaultWsConfig,
      [monadTestnet.id]: defaultWsConfig,
    },
  });

export const config = getConfig();
// use for event subscription only
export const wsConfig = getWsConfig();